import { Route } from '@angular/router';
import {
  CenterNoticePermissions,
  CenterPaymentPermissions,
  CenterRolePermissions,
  CenterTemplatePermissions,
  CenterUserInvitePermissions,
  CenterUserJoinRequestPermissions,
} from '@malirang/common';
import { CenterLayout } from '../pages/center/center.layout';
import { CenterJoinLayout } from '../pages/center/join/center-join.layout';
import { centerRoleFormGuard } from '../pages/center/role/center-role-form.guard';
import { CenterTemplateLayout } from '../pages/center/template/center-template.layout';

export const centerRoutes: Route[] = [
  {
    path: 'center',
    component: CenterLayout,
    title: `센터 관리`,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'info',
      },
      {
        path: 'info',
        loadComponent: () => import('../pages/center/info/center-info.page'),
      },
      {
        path: 'join',
        component: CenterJoinLayout,
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'invite' },
          {
            path: 'invite',
            data: {
              requiredRoles: [
                CenterUserInvitePermissions.CENTER_USER_INVITE_READ,
              ],
            },
            loadComponent: () =>
              import('../pages/center/join/invite/center-invite.page'),
          },
          {
            path: 'request',
            data: {
              requiredRoles: [
                CenterUserJoinRequestPermissions.CENTER_USER_JOIN_REQUEST_READ,
              ],
            },
            loadComponent: () =>
              import('../pages/center/join/request/center-join-request.page'),
          },
        ],
      },
      {
        path: 'role',
        data: {
          requiredRoles: [CenterRolePermissions.CENTER_ROLE_EDIT],
        },
        canDeactivate: [centerRoleFormGuard],
        loadComponent: () => import('../pages/center/role/center-role.page'),
      },
      {
        path: 'notice',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../pages/center/notice/center-notice.page'),
          },
          {
            path: 'form',
            data: {
              requiredRoles: [CenterNoticePermissions.CENTER_NOTICE_EDIT],
            },
            loadComponent: () =>
              import(
                '../pages/center/notice/center-notice-form/center-notice-form.page'
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                '../pages/center/notice/center-notice-detail/center-notice-detail.page'
              ),
          },
        ],
      },
      {
        path: 'template',
        data: {
          requiredRoles: [CenterTemplatePermissions.CENTER_TEMPLATE_READ],
        },
        component: CenterTemplateLayout,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'ticket',
          },
          {
            path: 'ticket',
            loadComponent: () =>
              import(
                '../pages/center/template/ticket/center-template-ticket.page'
              ),
          },
          {
            path: 'voucher',
            loadComponent: () =>
              import(
                '../pages/center/template/voucher/center-template-voucher.page'
              ),
          },
          {
            path: 'tag',
            loadComponent: () =>
              import('../pages/center/template/tag/center-child-tag.page'),
          },
          {
            path: 'ticket-type',
            loadComponent: () =>
              import(
                '../pages/center/template/ticket-type/center-ticket-type.page'
              ),
          },
        ],
      },
      {
        path: 'payment',
        data: {
          requiredRoles: [CenterPaymentPermissions.CENTER_PAYMENT],
        },
        loadComponent: () =>
          import('../pages/center/payment/center-payment.page'),
      },
      {
        path: 'notification',
        loadComponent: () =>
          import('../pages/center/notification/center-notification.page'),
      },
    ],
  },
  {
    path: 'center/form',
    title: `센터 등록`,
    loadComponent: () => import('../pages/center/form/center-form.page'),
  },
  {
    path: 'center/find',
    title: `센터 찾기`,
    loadComponent: () => import('../pages/center/find/find-center.page'),
  },
];
